import { useFeatures } from '@/platform/composables/useFeatures';

export default function useExperimentA15() {
  const { projectsWorkerBeeLogTimeCtaEnabled } = useFeatures();
  const EXP_A15_FLAG_KEY = 'projects-exp-a-23-15-worker-bee-log-time-ctas';
  const EXP_A15_COMMON_METRICS = [
    'account_id',
    'on_trial',
    'plan_name',
    'user_role',
    'page',
  ];

  return {
    projectsWorkerBeeLogTimeCtaEnabled,
    EXP_A15_COMMON_METRICS,
    EXP_A15_FLAG_KEY,
  };
}
